export function handleFileDownloadResponse(response){
    const file = new Blob([response.content], {
        type: response.contentType,
      });
      const fileUrl = URL.createObjectURL(file);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = fileUrl;
      a.download = response.fileName;
      a.click();
      a.remove();
}